import { useAuth0Context } from "@/context/Auth0Context";
import React, { type ReactNode } from "react";
import UserHeader from "../nav/UserHeader";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className = "",
}) => {
  const { user } = useAuth0Context();

  return (
    <div className={`bg-blue-dark-hover relative min-h-screen ${className}`}>
      <div className="absolute top-5 right-2 left-2 z-20">
        <UserHeader user={user} variant="glass" />
      </div>

      <main className="relative">{children}</main>
    </div>
  );
};

export default PageLayout;
